import * as classValidator from 'class-validator';
import { AxiosPromise } from 'axios';

import { axios } from 'src/app/utils';
import { urlsConfig } from 'src/configs';
import { queryTypes, serviceOntologyTypes } from 'src/types';
import { urlHelper } from '../helpers';

export const lookupOntology = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
}: serviceOntologyTypes.OntologyLookupDataType): AxiosPromise<serviceOntologyTypes.OntologyLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.ontology.lookupOntology), {
    blockSpinner,
  });

  // if (ids) {
  //   return axios.get(urlHelper.addQueryParameters({ ids: ids.join() }, urlsConfig.ontology.lookupOntology), {
  //     blockSpinner,
  //   });
  // }
  // if (value) {
  //   return axios.get(urlHelper.addQueryParameters({ search: value }, urlsConfig.ontology.lookupOntology), {
  //     blockSpinner,
  //   });
  // }

  // if (
  //   classValidator.isDefined(limit) &&
  //   classValidator.isDefined(offset) &&
  //   limit !== undefined &&
  //   offset !== undefined
  // ) {
  //   return axios.get(
  //     urlHelper.addQueryParameters(
  //       { limit: limit.toString(), offset: offset.toString() },
  //       urlsConfig.ontology.lookupOntology,
  //     ),
  //     {
  //       blockSpinner,
  //     },
  //   );
  // }

  // if (load) {
  //   return axios.get(urlHelper.addQueryParameters({ load: load.toString() }, urlsConfig.ontology.lookupOntology), {
  //     blockSpinner,
  //   });
  // }

  // return axios.get(urlsConfig.ontology.lookupOntology, {
  //   blockSpinner,
  // });
};

export const lookupOntologiesOfEvent = (
  eventId: string,
): AxiosPromise<serviceOntologyTypes.OntologyLookupResultType> => {
  return axios.get(`${urlsConfig.ontology.ontologiesOfEvent}/${eventId}`);
};

export const createOntologyOfEvent = (
  form: serviceOntologyTypes.OntologyDataType,
  options: { blockErrorHandler: boolean },
): AxiosPromise<serviceOntologyTypes.OntologyCreateResultType> => {
  return axios.post(urlsConfig.ontology.ontologiesOfEvent, form, { blockErrorHandler: true });
};

export const ontologyEdit = (
  form: serviceOntologyTypes.OntologyEditDataType,
): AxiosPromise<serviceOntologyTypes.OntologyEditDataType> => {
  return axios.patch(urlsConfig.ontology.ontologyEdit, form, { blockErrorHandler: true });
};

export const deleteOntologyOfEvent = ({
  id,
}: serviceOntologyTypes.OntologyDeleteDataType): AxiosPromise<serviceOntologyTypes.OntologyDeleteResultType> => {
  return axios.delete(`${urlsConfig.ontology.ontologiesOfEvent}/${id}`);
};

export const deleteOntologiesFromEvent = (
  ontologyIds: string[],
): AxiosPromise<serviceOntologyTypes.OntologyDeleteResultType> => {
  return axios.post(urlsConfig.ontology.bulkRemoveFromEvent, ontologyIds);
};
